import Modal from '@mui/material/Modal';
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
export default function CssMod() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button onClick={handleOpen} style={{color:'teal'}}>Introduction to CSS</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        
      >
        <Box sx={style} height={300} width={300} style={{'background':'aquamarine'}}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Introduction to CSS
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          Cascading Style Sheets (CSS) is a language that describes the presentation of 
          a document written in a markup language, such as HTML.<br/>
It controls the visual appearance of web pages, including colors, fonts, layout, spacing, and more.<br/>
It separates content (HTML) from presentation (CSS), making websites more maintainable and adaptable.

          </Typography>
        </Box>
      </Modal>
    </div>
  );
}